<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.tld_mappings.form.tld')"
            :is-required="true"
        >
            <DInput
                id="tld"
                v-model="form.tld"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('tld')"
                :invalid-feedback="errors.tld"
                maxlength="45"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.tld_mappings.form.product_id')"
            add-input-classes="bg-light"
            :is-required="true"
            :error="errors.product_id"
        >
            <DMultiSelect
                id="product_id"
                v-model="form.product_id"
                :options="productOptions"
                :multiple="false"
                options-style="text"
                :is-valid="isFormFieldValid('product_id')"
                @update="(value) => updateValue(value)"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.tld_mappings.form.customer_id')"
        >
            <DInput
                id="customer_id"
                v-model="form.customer_id"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('customer_id')"
                :invalid-feedback="errors.customer_id"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="route('products.tld-product-mappings.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed } from 'vue'
import _ from 'lodash'

const props = defineProps({
    tldMapping: {
        type: Object,
        default: () => { return {} }
    },
    products: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    tld: props.tldMapping?.tld ?? null,
    customer_id: props.tldMapping?.customer_id ?? null,
    product_id: props.tldMapping?.product_id ?? null
})

const productOptions = computed(() => {
    const products = _.cloneDeep(props.products)
    products.forEach((item, index) => {
        item.options.forEach((optionItem, optionIndex) => {
            if (optionItem.value === props.tldMapping.product_id) {
                products[index].options[optionIndex].selected = true
            }
        })
    })

    return products
})
const emit = defineEmits(['form-submitted'])
function submitForm () {
    emit('form-submitted', form)
}

function updateValue (value) {
    form.product_id = value[0]
}

</script>
